export const primarycolor='#00008B'

//const primarycolor='#00008B' 
//const lightercolor='#57E964' 